const API_BASE = '';

async function parseResponse(res) {
  const json = await res.json();
  if (!res.ok) {
    throw new Error(json?.message || `请求失败 (${res.status})`);
  }
  if (json && typeof json === 'object' && 'code' in json) {
    if (json.code !== 0) throw new Error(json.message || '请求失败');
    return json.data;
  }
  return json;
}

export async function fetchPublicRooms() {
  const res = await fetch(`${API_BASE}/api/leli/party-screen/rooms/public`);
  return parseResponse(res);
}

export async function fetchRoomWxacode(roomId) {
  const res = await fetch(`${API_BASE}/api/leli/party-screen/display/${roomId}/wxacode-base64`);
  return parseResponse(res);
}

export async function fetchRoomDisplay(roomId) {
  const res = await fetch(`${API_BASE}/api/leli/party-screen/display/${roomId}`);
  return parseResponse(res);
}

export async function fetchCastCommand(roomId) {
  const res = await fetch(`${API_BASE}/api/leli/party-screen/display/${roomId}/command`);
  return parseResponse(res);
}

export async function fetchRoomDanmaku(roomId) {
  const res = await fetch(`${API_BASE}/api/leli/party-screen/display/${roomId}/danmaku`);
  return parseResponse(res);
}

export async function fetchRoomService(roomId) {
  const res = await fetch(`${API_BASE}/api/leli/party-screen/display/${roomId}/service`);
  return parseResponse(res);
}

export async function callRoomService(roomId, message) {
  const res = await fetch(`${API_BASE}/api/leli/party-screen/display/${roomId}/service/call`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ message }),
  });
  return parseResponse(res);
}

export async function ackRoomService(roomId, requestId) {
  const res = await fetch(`${API_BASE}/api/leli/party-screen/display/${roomId}/service/ack`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ request_id: requestId }),
  });
  return parseResponse(res);
}
